import { useQuery } from '@tanstack/react-query';

import { AuthorizationRequestType, FlightEventClient, FlightEventReport, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useGetFlightEventReport(id: number, role: AuthorizationRequestType) {
  return useQuery<FlightEventReport, ProblemDetails>({
    queryKey: [queryKeys.FlightEvent.FlightEventReport, { id }],
    queryFn: () => flightEventClient.get(id, role),
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export default useGetFlightEventReport;
